import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './StoryMenu.css';
import StoryInspire from './StoryInspire';
import StoryIdeas from './StoryIdeas';
import StoryCreate from './StoryCreate';

const StoryMenu = () => {
    const [activeTab, setActiveTab] = useState('inspire');
    const navigate = useNavigate();

    const tabs = [
        { id: 'inspire', label: 'Explore' },
        { id: 'ideas', label: 'Boards' },
        { id: 'create', label: 'Create' },
    ];

    const renderContent = () => {
        switch (activeTab) {
            case 'inspire':
                return <StoryInspire />;
            case 'ideas':
                return <StoryIdeas />;
            case 'create':
                return <StoryCreate />;
            default:
                return <StoryInspire />;
        }
    };

    return (
        <div className="story-menu-container">
            <div className="story-topbar">
                <button className="story-back-btn" onClick={() => navigate('/')}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 9l4-4l4 4" />
                        <path d="M7 5v9a4 4 0 0 0 4 4h8" />
                    </svg>
                    Dashboard
                </button>

                <div className="story-tab-pills">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            className={`story-pill ${activeTab === tab.id ? 'story-pill-active' : ''}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                <div className="story-topbar-spacer" />
            </div>

            <div className="story-menu-content">
                {renderContent()}
            </div>
        </div>
    );
};

export default StoryMenu; 